export default "__VITE_ASSET__DWjFgbJd__"